import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonModal, ToastController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';
import { CAESAR_OPCIOK } from '../caesar.opciok';

// Központi személy-törzs. Lista + kereső; a részletek modálban segmensekkel
// (adatok / címek / okmányok / JÜB / kapcsolódó ügyek). Új felvitelkor névre dedup-figyelés.
@Component({
  selector: 'app-caesar-szemelyek',
  templateUrl: './szemelyek.component.html',
  styleUrls: ['./szemelyek.component.scss'],
})
export class SzemelyekComponent implements OnInit {
  @ViewChild('szemelyModal') szemelyModal: IonModal;
  @ViewChild('jubPdfModal') jubPdfModal: IonModal;
  @ViewChild('jubBulkModal') jubBulkModal: IonModal;
  opciok = CAESAR_OPCIOK;

  // JÜB fájl (PDF/es3) feldolgozás (előnézet + mentés + tömeges)
  jubFeldolgozas = false;
  jubParsed: any = null;
  jubTalalat: any = null;
  jubCel: 'uj' | 'meglevo' = 'uj';
  jubCelSzemelyId = '';
  jubFile: any = null;             // a kiválasztott fájl – mentéskor tároljuk
  jubBulkEredmeny: any = null;     // tömeges feldolgozás eredménye
  jubFigyelmeztetes = '';          // pl. kérelmi es3 (nincs benne a lekérdezett személy neve)
  intezmeny = '';
  szemelyek: any[] = [];
  szuro = '';

  segment = 'adatok';
  szerk: any = null;               // a szerkesztett törzsadat
  reszletek: any = { cimek: [], okmanyok: [], jub: [], ugyek: [] };
  hasonloak: any[] = [];           // dedup-találatok új felvitelkor

  // gyorsűrlapok a gyermek-rekordokhoz
  ujCim: any = { tipus: 'lakcim', cim: '', alapertelmezett: false };
  ujOkmany: any = { tipus: 'szig', szam: '', ervenyesseg: null };
  ujJub: any = { datum: new Date().toISOString().slice(0, 10), azonosito: '', nyers: '' };

  constructor(private http: HttpClient, private data: DataService, private toast: ToastController, private alert: AlertController) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = si?.intezmenyId || '';
    await this.betolt();
  }

  async betolt() {
    try { this.szemelyek = await firstValueFrom(this.http.get<any[]>('/api/caesar/szemelyek/' + this.intezmeny)); }
    catch { this.hiba('Nem sikerült betölteni a személyeket.'); }
  }

  get szurtSzemelyek() {
    const q = this.szuro.trim().toLowerCase();
    if (!q) return this.szemelyek;
    return this.szemelyek.filter((s) => [s.nev, s.email, s.telefon].filter(Boolean).some((v) => String(v).toLowerCase().includes(q)));
  }

  uj() {
    this.szerk = { intezmeny: this.intezmeny, tipus: 'termeszetes', nev: '' };
    this.reszletek = { cimek: [], okmanyok: [], jub: [], ugyek: [] };
    this.hasonloak = [];
    this.segment = 'adatok';
    this.szemelyModal.present();
  }

  async megnyit(s: any) {
    this.segment = 'adatok';
    this.hasonloak = [];
    try {
      const r: any = await firstValueFrom(this.http.get('/api/caesar/szemely/' + s.id));
      this.szerk = { ...r.szemely, intezmeny: this.intezmeny, formazas_tiltva: !!r.szemely.formazas_tiltva };
      this.reszletek = { cimek: r.cimek || [], okmanyok: r.okmanyok || [], jub: r.jub || [], ugyek: r.ugyek || [] };
      this.szemelyModal.present();
    } catch { this.hiba('Nem sikerült megnyitni a személyt.'); }
  }

  // Dedup: új személynél a név gépelésekor hasonló nevűek figyelése.
  async nevValtozott() {
    if (this.szerk?.id) return;
    const q = (this.szerk?.nev || '').trim();
    if (q.length < 3) { this.hasonloak = []; return; }
    try {
      this.hasonloak = await firstValueFrom(this.http.get<any[]>('/api/caesar/szemelyek/' + this.intezmeny + '?q=' + encodeURIComponent(q)));
    } catch { this.hasonloak = []; }
  }

  async mentes() {
    if (!this.szerk?.nev?.trim()) return this.hiba('A név kötelező.');
    this.szerk.intezmeny = this.intezmeny;
    try {
      if (this.szerk.id) {
        await firstValueFrom(this.http.put('/api/caesar/szemely/' + this.szerk.id, this.szerk));
      } else {
        const r: any = await firstValueFrom(this.http.post('/api/caesar/szemely', this.szerk));
        this.szerk.id = r.id; // a gyermek-rekordokhoz kell az id
      }
      await this.betolt();
      this.ok('Mentve.');
    } catch { this.hiba('Nem sikerült menteni a személyt.'); }
  }

  async torol(s: any) {
    const a = await this.alert.create({
      header: 'Törlés', message: `Biztosan törli: ${s.nev}?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, {
        text: 'Törlés', role: 'destructive', handler: async () => {
          try { await firstValueFrom(this.http.delete('/api/caesar/szemely/' + s.id)); await this.betolt(); this.ok('Törölve.'); }
          catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
        }
      }],
    });
    a.present();
  }

  /* ---- gyermek-rekordok (csak mentett személyen) ---- */
  private async friss() {
    const r: any = await firstValueFrom(this.http.get('/api/caesar/szemely/' + this.szerk.id));
    this.reszletek = { cimek: r.cimek || [], okmanyok: r.okmanyok || [], jub: r.jub || [], ugyek: r.ugyek || [] };
  }

  async cimHozzaad() {
    if (!this.szerk?.id) return this.hiba('Előbb mentsd a személyt.');
    if (!this.ujCim.cim.trim()) return;
    await firstValueFrom(this.http.post('/api/caesar/szemely/' + this.szerk.id + '/cim', this.ujCim));
    this.ujCim = { tipus: 'lakcim', cim: '', alapertelmezett: false };
    await this.friss();
  }
  async cimTorol(id: string) { await firstValueFrom(this.http.delete('/api/caesar/cim/' + id)); await this.friss(); }

  async okmanyHozzaad() {
    if (!this.szerk?.id) return this.hiba('Előbb mentsd a személyt.');
    if (!this.ujOkmany.szam.trim()) return;
    await firstValueFrom(this.http.post('/api/caesar/szemely/' + this.szerk.id + '/okmany', this.ujOkmany));
    this.ujOkmany = { tipus: 'szig', szam: '', ervenyesseg: null };
    await this.friss();
  }
  async okmanyTorol(id: string) { await firstValueFrom(this.http.delete('/api/caesar/okmany/' + id)); await this.friss(); }

  async jubHozzaad() {
    if (!this.szerk?.id) return this.hiba('Előbb mentsd a személyt.');
    await firstValueFrom(this.http.post('/api/caesar/szemely/' + this.szerk.id + '/jub', this.ujJub));
    this.ujJub = { datum: new Date().toISOString().slice(0, 10), azonosito: '', nyers: '' };
    await this.friss();
  }
  async jubTorol(id: string) { await firstValueFrom(this.http.delete('/api/caesar/jub/' + id)); await this.friss(); }

  /* ---- JÜB fájl (PDF / es3) feltöltés → kiolvasás → előnézet → mentés (tárolással) ---- */

  // A listából: a párosítást a backend végzi (személyi szám / név+szül. dátum), a célt utólag választható.
  async jubPdfValaszt(ev: any) {
    const file: File = ev.target.files?.[0];
    ev.target.value = '';
    if (file) await this.jubFeldolgoz(file, null);
  }
  // A nyitott személy JÜB füléről: fixen az adott személyhez.
  async jubPdfSzemelyhez(ev: any) {
    const file: File = ev.target.files?.[0];
    ev.target.value = '';
    if (file && this.szerk?.id) await this.jubFeldolgoz(file, this.szerk.id);
  }

  private async jubFeldolgoz(file: File, fixSzemelyId: string | null) {
    if (!/\.pdf$/i.test(file.name)) return this.hiba('PDF fájlt tölts fel.');
    this.jubFeldolgozas = true;
    try {
      const fd = new FormData();
      fd.append('file', file, file.name);
      const r: any = await firstValueFrom(this.http.post('/api/caesar/jub-file/' + this.intezmeny, fd));
      this.jubParsed = r.parsed;
      this.jubFigyelmeztetes = r.figyelmeztetes || '';
      this.jubFile = file;                 // a fájlt megőrizzük – mentéskor tároljuk
      this.jubTalalat = fixSzemelyId ? null : r.talalat;
      if (fixSzemelyId) { this.jubCel = 'meglevo'; this.jubCelSzemelyId = fixSzemelyId; }
      else if (r.talalat) { this.jubCel = 'meglevo'; this.jubCelSzemelyId = r.talalat.id; }
      else { this.jubCel = 'uj'; this.jubCelSzemelyId = ''; }
      await this.jubPdfModal.present();
    } catch (e: any) {
      this.hiba(e?.error?.error || 'Nem sikerült feldolgozni a fájlt.');
    } finally { this.jubFeldolgozas = false; }
  }

  jubCimTorol(i: number) { this.jubParsed?.cimek?.splice(i, 1); }
  jubOkmanyTorol(i: number) { this.jubParsed?.okmanyok?.splice(i, 1); }

  async jubPdfMentes() {
    if (!this.jubParsed?.nev?.trim()) return this.hiba('A név kötelező.');
    const fd = new FormData();
    fd.append('parsed', JSON.stringify(this.jubParsed));
    fd.append('cel', this.jubCel);
    if (this.jubCel === 'meglevo' && this.jubCelSzemelyId) fd.append('szemely_id', this.jubCelSzemelyId);
    if (this.jubFile) fd.append('file', this.jubFile, this.jubFile.name);
    try {
      const r: any = await firstValueFrom(this.http.post('/api/caesar/jub-commit/' + this.intezmeny, fd));
      await this.jubPdfModal.dismiss();
      this.jubFile = null;
      await this.betolt();
      this.ok(r.created ? 'Új személy létrehozva a JÜB adatokból.' : 'JÜB adatok elmentve.');
      if (this.szerk?.id && this.szerk.id === r.szemely_id) { await this.friss(); }
      else { const sz = this.szemelyek.find((x) => x.id === r.szemely_id); if (sz) await this.megnyit(sz); }
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni az adatokat.'); }
  }

  // Tömeges feldolgozás: egy ZIP-ben több PDF/es3 → automatikus személy-társítás + tárolás.
  async jubBulk(ev: any) {
    const file: File = ev.target.files?.[0];
    ev.target.value = '';
    if (!file) return;
    if (!/\.zip$/i.test(file.name)) return this.hiba('ZIP fájlt tölts fel (benne PDF fájlokkal).');
    this.jubFeldolgozas = true;
    try {
      const fd = new FormData();
      fd.append('file', file, file.name);
      const r: any = await firstValueFrom(this.http.post('/api/caesar/jub-bulk/' + this.intezmeny, fd));
      this.jubBulkEredmeny = r.eredmeny || [];
      await this.betolt();
      await this.jubBulkModal.present();
    } catch (e: any) {
      this.hiba(e?.error?.error || 'Nem sikerült feldolgozni a ZIP-et.');
    } finally { this.jubFeldolgozas = false; }
  }

  // A személyhez tárolt JÜB fájl megnyitása. FONTOS: blobként, HttpClienttel kérjük le, hogy az
  // auth-interceptor rátegye a tokent – a sima window.open(url) nem hordozná a tokent → 401.
  async jubMegnyit(j: any, valt: 'pdf' | 'eredeti') {
    try {
      const blob = await firstValueFrom(this.http.get('/api/caesar/jub/' + j.id + '/download?valt=' + valt, { responseType: 'blob' }));
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch { this.hiba('Nem sikerült megnyitni a fájlt.'); }
  }

  cimke(lista: any[], v: string) { return lista.find((x) => x.value === v)?.label || v || ''; }
  ikon(tipus: string) { return tipus === 'jogi' ? 'business' : tipus === 'hatosag' ? 'shield' : 'person'; }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1800, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2500, color: 'danger' })).present(); }
}
